<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerRouteCodes">
        <template #header>
          <ProSpaceAction :text="$t('editItemTxt')" @click="editPanel" />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { RouteCodeService } from "../../../services/RouteCodeService";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "RouteCodePanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
    checkAccess: {
      type: Function,
    }
  },
  data() {
    return {
      routeCode: null,
      routeCodeService: new RouteCodeService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerRouteCodes() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.routeCode) {
        return {
          title: this.routeCode.value,
          id: this.ids[0],
          status: this.getStatus(this.routeCode.status),
          options: this.options,
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      let content = [];
      if (this.routeCode) {
        content.push([{ title: this.$t("routeCodeValue"), text: this.routeCode.value }]);
        if (this.checkAccess && this.checkAccess("agencyValue-rightPanel"))
            content.push([{ title: this.$t("routeCodeAgencyValue"), text: this.routeCode.agencyValue }]);
      }
      return content;
    },
    contentBottom() {
      if (this.routeCode) {
        return [
        [
            {
              title: this.$t("createdByTxt"),
              text: this.routeCode.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.routeCode.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.routeCode.createdAt) + ' ' + getAMorPM(this.routeCode.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.routeCode.lastUpdated) + ' ' + getAMorPM(this.routeCode.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    update() {
      this.hasError = false;
      try {
        this.getRouteCode();
      } catch (e) {
        this.hasError = true;
      }
    },
    getRouteCode() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.routeCodeService.get(this.ids[0]).then((res) => {
          this.routeCode = res.data;
          this.loading = false;
        });
      }
      this.routeCode = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.routeCode);
    },
    deletePanel() {
      this.$emit("delete", this.routeCode);
    },
    showHistoryPanel() {
      this.$emit("history", this.routeCode);
    },
  },
};
</script>

<style scoped></style>
